import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import Brand from './Brand'

const IndexEquipment = () => {
  return (
    <div><TextMediumSM content="Equipment" />
    <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
    <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
        <Brand/>
     </div>
     
    
   
     </div></div>
  )
}

export default IndexEquipment